export type NfseTemplateVariableCategory =
  | 'invoice'
  | 'customer'
  | 'amounts'
  | 'withholding'
  | 'service';

export interface NfseTemplateVariableDefinition {
  /** Placeholder key used inside `{{key}}` */
  key: string;
  category: NfseTemplateVariableCategory;
  /** i18n path suffix under `billing.nfseTemplateVariables` */
  labelKey: string;
  descriptionKey: string;
}

export const NFSE_TEMPLATE_VARIABLES: NfseTemplateVariableDefinition[] = [
  {
    key: 'invoice_number',
    category: 'invoice',
    labelKey: 'invoiceNumber',
    descriptionKey: 'invoiceNumber',
  },
  {
    key: 'description',
    category: 'invoice',
    labelKey: 'description',
    descriptionKey: 'description',
  },
  {
    key: 'issue_date',
    category: 'invoice',
    labelKey: 'issueDate',
    descriptionKey: 'issueDate',
  },
  {
    key: 'due_date',
    category: 'invoice',
    labelKey: 'dueDate',
    descriptionKey: 'dueDate',
  },
  {
    key: 'managerial_date',
    category: 'invoice',
    labelKey: 'managerialDate',
    descriptionKey: 'managerialDate',
  },
  {
    key: 'competency_date',
    category: 'invoice',
    labelKey: 'competencyDate',
    descriptionKey: 'competencyDate',
  },
  {
    key: 'external_ref',
    category: 'invoice',
    labelKey: 'externalRef',
    descriptionKey: 'externalRef',
  },
  {
    key: 'line_descriptions',
    category: 'invoice',
    labelKey: 'lineDescriptions',
    descriptionKey: 'lineDescriptions',
  },
  {
    key: 'customer_name',
    category: 'customer',
    labelKey: 'customerName',
    descriptionKey: 'customerName',
  },
  {
    key: 'customer_legal_name',
    category: 'customer',
    labelKey: 'customerLegalName',
    descriptionKey: 'customerLegalName',
  },
  {
    key: 'customer_trade_name',
    category: 'customer',
    labelKey: 'customerTradeName',
    descriptionKey: 'customerTradeName',
  },
  {
    key: 'customer_code',
    category: 'customer',
    labelKey: 'customerCode',
    descriptionKey: 'customerCode',
  },
  {
    key: 'customer_tax_id',
    category: 'customer',
    labelKey: 'customerTaxId',
    descriptionKey: 'customerTaxId',
  },
  {
    key: 'customer_email',
    category: 'customer',
    labelKey: 'customerEmail',
    descriptionKey: 'customerEmail',
  },
  {
    key: 'entity_name',
    category: 'invoice',
    labelKey: 'entityName',
    descriptionKey: 'entityName',
  },
  {
    key: 'gross_amount',
    category: 'amounts',
    labelKey: 'grossAmount',
    descriptionKey: 'grossAmount',
  },
  {
    key: 'net_amount',
    category: 'amounts',
    labelKey: 'netAmount',
    descriptionKey: 'netAmount',
  },
  {
    key: 'withholding_total',
    category: 'amounts',
    labelKey: 'withholdingTotal',
    descriptionKey: 'withholdingTotal',
  },
  {
    key: 'withholding_irrf',
    category: 'withholding',
    labelKey: 'withholdingIrrf',
    descriptionKey: 'withholdingIrrf',
  },
  {
    key: 'withholding_pis',
    category: 'withholding',
    labelKey: 'withholdingPis',
    descriptionKey: 'withholdingPis',
  },
  {
    key: 'withholding_cofins',
    category: 'withholding',
    labelKey: 'withholdingCofins',
    descriptionKey: 'withholdingCofins',
  },
  {
    key: 'withholding_csll',
    category: 'withholding',
    labelKey: 'withholdingCsll',
    descriptionKey: 'withholdingCsll',
  },
  {
    key: 'withholding_csrf',
    category: 'withholding',
    labelKey: 'withholdingCsrf',
    descriptionKey: 'withholdingCsrf',
  },
  {
    key: 'withholding_inss',
    category: 'withholding',
    labelKey: 'withholdingInss',
    descriptionKey: 'withholdingInss',
  },
  {
    key: 'withholding_iss',
    category: 'withholding',
    labelKey: 'withholdingIss',
    descriptionKey: 'withholdingIss',
  },
  {
    key: 'service_code',
    category: 'service',
    labelKey: 'serviceCode',
    descriptionKey: 'serviceCode',
  },
];

export const NFSE_TEMPLATE_VARIABLE_PLACEHOLDER_PREFIX = '{{';
export const NFSE_TEMPLATE_VARIABLE_PLACEHOLDER_SUFFIX = '}}';

export function formatNfseTemplateVariablePlaceholder(key: string): string {
  return `${NFSE_TEMPLATE_VARIABLE_PLACEHOLDER_PREFIX}${key}${NFSE_TEMPLATE_VARIABLE_PLACEHOLDER_SUFFIX}`;
}
